import { FeedbackType } from '@/core/api/entities/song/feedbackType'
import { Song } from '@/core/api/entities/song/song'
import { SongFeedback } from '@/core/api/entities/song/songFeedback'
import Icon from '@/shared/components/atoms/Icon'

interface HandThumbsUpProps {
	songFeedbacks: Map<number, SongFeedback>
	song: Song
	feedbackTypes: FeedbackType[]
}

export const HandThumbsUp = ({
	songFeedbacks,
	song,
	feedbackTypes,
}: HandThumbsUpProps) => {
	return (
		<Icon
			name="hand-thumbs-up"
			width="16px"
			height="16px"
			color={(() => {
				const songFeedback = songFeedbacks.get(song.id)
				if (!songFeedback) {
					return 'var(--muted-foreground)'
				}

				const feedbackType =
					feedbackTypes?.filter(
						(type) => type.id === songFeedback.feedbackTypeId
					) || []
				if (feedbackType.length > 0) {
					return feedbackType[0].isPositive()
						? 'var(--foreground)'
						: 'var(--muted-foreground)'
				}

				return 'var(--muted-foreground)'
			})()}
			hoverColor="white"
		/>
	)
}

interface HandThumbsDownProps {
	songFeedbacks: Map<number, SongFeedback>
	song: Song
	feedbackTypes: FeedbackType[]
}

export const HandThumbsDown = ({
	songFeedbacks,
	song,
	feedbackTypes,
}: HandThumbsDownProps) => {
	return (
		<Icon
			name="hand-thumbs-down"
			width="16px"
			height="16px"
			color={(() => {
				const songFeedback = songFeedbacks.get(song.id)
				if (!songFeedback) {
					return 'var(--muted-foreground)'
				}

				const feedbackType =
					feedbackTypes?.filter(
						(type) => type.id === songFeedback.feedbackTypeId
					) || []
				if (feedbackType.length > 0) {
					return feedbackType[0].isNegative
						? 'var(--foreground)'
						: 'var(--muted-foreground)'
				}

				return 'var(--muted-foreground)'
			})()}
			hoverColor="white"
		/>
	)
}
